import { HorizontalContainer } from '@american-autonomy/ag-ui';

import PrimaryButton from 'components/buttons/PrimaryButton';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

// Shared cancel/confirm footer for the maintenance panels. The optional secondary
// action covers the return-to-service footer's three-button case.
const PanelActionFooter: FunctionComponent<Props> = ({
    cancelTestId,
    cancelText,
    className = '',
    isPrimaryDisabled = false,
    onCancel,
    onPrimary,
    onSecondary,
    primaryTestId,
    primaryText,
    secondaryTestId,
    secondaryText,
    testId = TEST_ID
}) => (
    <HorizontalContainer className={`${styles.panelActionFooter} ${className}`} testId={testId}>
        <PrimaryButton
            className={`${styles.actionButton} ${styles.cancelButton}`}
            onClick={onCancel}
            testId={cancelTestId}
            text={cancelText}
        />

        {onSecondary && secondaryText && (
            <PrimaryButton
                className={styles.actionButton}
                onClick={onSecondary}
                testId={secondaryTestId}
                text={secondaryText}
            />
        )}

        <PrimaryButton
            className={styles.actionButton}
            isDisabled={isPrimaryDisabled}
            onClick={onPrimary}
            testId={primaryTestId}
            text={primaryText}
        />
    </HorizontalContainer>
);

export default PanelActionFooter;
